import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import getPermissions from './Permissions';
import _ from 'lodash';

export const FULL_ACCESS_USERS = ['admin1@vibino.ir', 'admin2@vibino.ir', 'admin1@gmail.com'];
export const isFullAccessUser = username =>
    FULL_ACCESS_USERS.includes(String(username || '').trim().toLowerCase());

const CheckPermission = (props) => {
    const permissions = getPermissions();
    const user = useSelector(state => state.authentication.user) || {};
    const role = String(user.role || '').trim().toLowerCase();
    const group = user.group;
    const actions = Array.isArray(props.action) ? props.action : [props.action];
    let couldShow;

    if (role === 'admin' || role === 'superadmin' || isFullAccessUser(user.username)) {
        couldShow = true;
    } else if (props.resource) {
        couldShow = _.find(permissions, function (o) {
            if (!props.group || props.group === group) {
                const actionAllowed = actions.some(action => o.action.includes(action));
                if ((props.allowed && !props.group) || (props.allowed && props.group === group))
                    return o.role.toLowerCase() === role && o.resource === props.resource && actionAllowed && (o.attributes.includes(props.allowed) || o.attributes === '*')
                else
                    return o.role.toLowerCase() === role && o.resource === props.resource && actionAllowed
            } else {
                return false;
            }
        })
    } else {
        couldShow = false;
    }
    return couldShow ? props.children : null;
};

CheckPermission.propTypes = {
    resource: PropTypes.string.isRequired,
    action: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.string,
    ]).isRequired,
    allowed: PropTypes.string,
    group: PropTypes.string,
    children: PropTypes.node.isRequired,
};


export default CheckPermission;
